import gql from 'graphql-tag';

export default gql`
  fragment poolProspectCustomizeItemFragment on PoolProspectCustomizeItem {
    id
    name
    dataType
    dataTypeText
    position
    isDisplay
    isDeleted
    selectOptions {
      id
      label
    }
    formBlockFieldCustomizeItems {
      id
    }
  }
`;
